import React, { useMemo } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from '../components/Loading';
import ErrorMessageBox from '../components/ErrorMessageBox';
import { Pagination } from '../components/Pagination';
import { scrollToElement } from '../../lib/userFunctions';
import useQueryString from '../../utils/hooks/useQueryString';
import BookReportItem from './BookReportItem';
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getBookReportList } from './apiBookReport';
import { createFetchErrorMessage } from 'utils/api/Api';
const queryString = require('query-string');

export const BookReportList = ({path=null, forcedData={}})=>{
    const navigate = useNavigate();
    const { school } = useParams();
    const queryParams = useQueryString();
    
    const requestData = useMemo(() => {
        const paramJson = { bestYn:'N', page:0, isbn:'', school:'', user:null };
        return {...paramJson, ...queryParams, ...forcedData};
    }, [queryParams, forcedData]);
    

    const {data:bookReportList, isFetching, isError, error  } = useQuery({
        queryKey:['bookreport/list', requestData], 
        queryFn:getBookReportList,
        placeholderData:keepPreviousData,
        refetchOnMount:'always'
    });

    const fetchList = (page = 0, optionData={})=>{
        let tempSearchOption = {...requestData, ...optionData, page:page };
        scrollToElement();
        navigate({ pathname:path||`/${school}/bookreport` , search: "?" + queryString.stringify(tempSearchOption) });
    }

    const list = useMemo(()=>{
        if( isError) return <ErrorMessageBox message={ createFetchErrorMessage(error).message } />;
        if( bookReportList?.data?.list.length <= 0) return <div className="no_data"><p>등록된 독서감상문이 없습니다.</p></div>;
        
        return bookReportList?.data?.list.map((report) => {
            return <BookReportItem  key={report.id} report={report}/>;
        });
    }, [bookReportList, error, isError]);

    
    
    return (
        <>
            <div className="inner tab_cont_area">
                <div className="alignR">
                    {!requestData.user && <button type="button" onClick={()=>fetchList(0, {school:requestData.school===school?'':school})} className={`btn circleCheck ${requestData.school!==''?'on':''}`} >우리학교</button>}
                    <button type="button" onClick={()=>fetchList(0, {bestYn:requestData.bestYn==='Y'?null:'Y'})} className={`btn circleCheck ${requestData.bestYn==='Y'?'on':''}`} >우수</button>
                </div>
                

                <div className="activity_list _report bdT0">
                    { list }
                    <Loading overlay={true} active={isFetching} />
                </div>
            </div>
            <Pagination page={bookReportList?.data?.page} totalPage={bookReportList?.data?.totalPages} gotoPage={fetchList} />
        </>
    );
}